export default "__VITE_ASSET__B5_tNNp2__"